import PropTypes from 'prop-types'
import styled from 'styled-components/macro'

import { getToken } from '@loadsmart/loadsmart-ui/dist/theming'

import { ButtonAction as Button } from 'legacy/components/Button/ButtonAction'
import DialogCloseLink from 'legacy/components/DialogCloseLink'
import DialogContent from 'legacy/components/DialogContent'
import DialogWrapper from 'legacy/components/DialogWrapper'
import Alert from 'legacy/components/FormAlert/FormAlert'
import I18n from 'legacy/components/I18n/i18n'
import InputForm from 'legacy/components/Input/Input'
import URL from 'legacy/components/URL/URL'
import { screen } from 'legacy/styles/screen'

const Content = styled(DialogContent)`
  width: 100%;
  padding: 40px 36px 40px;

  color: ${getToken('color-neutral-darkest')};
  background: ${getToken('color-neutral-lightest')};

  border-radius: 4px;

  ${screen.lg} {
    width: 400px;
    padding: 40px 36px;
  }
`

const Input = styled(InputForm)`
  margin-bottom: 5px;
`

const InputWrapper = styled.div`
  position: relative;

  margin-bottom: 10px;
`

const Label = styled.label`
  display: block;
  margin-bottom: 5px;

  font-weight: 500;
  font-size: 13px;
  line-height: 17px;
  letter-spacing: 0;
`

const ForgotLink = styled.a`
  display: block;
  margin-bottom: 24px;

  color: ${getToken('color-primary')};

  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0;
  text-align: right;
  text-decoration: underline;
`

const WrapperButton = styled.div`
  text-align: center;

  ${screen.lg} {
    position: relative;

    text-align: right;
  }
`

const Title = styled.header`
  width: 326px;
  height: 29px;
  margin-bottom: 40px;

  color: ${getToken('color-neutral-darkest')};
  font-weight: bold;
  font-size: 22px;
  line-height: 29px;
  letter-spacing: 0;
`

const SignupBox = styled.div`
  display: block;
  margin-top: 25px;

  color: ${getToken('color-neutral-darkest')};
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0;
  text-align: center;
`

const SignupLink = styled.a`
  display: block;

  color: ${getToken('color-primary')};
  text-decoration: underline;

  cursor: pointer;
`

function LoginDialogInner(props) {
  const { values, touched, errors, handleChange, handleBlur, handleSubmit, state } = props

  return (
    <DialogWrapper
      ariaHideApp={false}
      isOpen={state}
      onRequestClose={props.onClose || props.onClick}
      contentLabel="Login Modal"
    >
      <Content>
        <Title aria-label="Log in at Loadsmart">Log in</Title>
        <form name="loginForm" onSubmit={handleSubmit} id="ls-FormLogin">
          {errors.validity && <Alert message={errors.validity} />}
          <InputWrapper>
            <Label>Email</Label>
            <Input
              placeholder={I18n.get('ls.components.LoginDialog.labels.email')}
              type="email"
              value={values.email}
              onChange={handleChange}
              onBlur={handleBlur}
              name="email"
            />
            {errors.email && touched.email && <Alert message={errors.email} />}
          </InputWrapper>

          <InputWrapper>
            <Label>Password</Label>
            <Input
              placeholder={I18n.get('ls.components.LoginDialog.labels.password')}
              type="password"
              value={values.password}
              onChange={handleChange}
              onBlur={handleBlur}
              name="password"
            />
            {errors.password && touched.password && <Alert message={errors.password} />}
          </InputWrapper>

          {props.forgot && (
            <ForgotLink
              href={URL.get('forgot').url}
              onClick={e => {
                e.preventDefault()
                props.onClick()
                props.forgot()
              }}
            >
              {I18n.get('ls.components.LoginDialog.link.forgot')}
            </ForgotLink>
          )}

          <WrapperButton>
            <Button width="100%" activated id="ls-FormLogin-button" type="submit">
              LOG IN
            </Button>
          </WrapperButton>

          {props.signup && (
            <SignupBox
              href={URL.get('signup').url}
              onClick={e => {
                e.preventDefault()
                props.onClick()
                props.signup()
              }}
              aria-label="Create your account"
            >
              {I18n.get('ls.components.LoginDialog.labels.noAccount')}
              <SignupLink>Click here</SignupLink>
            </SignupBox>
          )}
        </form>
        <DialogCloseLink
          as="span"
          className="ls-Dialog-close"
          role="button"
          aria-label="close modal"
          tabIndex="0"
          onClick={e => {
            e.preventDefault()
            props.onClose ? props.onClose() : props.onClick()
          }}
        >
          &nbsp;
        </DialogCloseLink>
      </Content>
    </DialogWrapper>
  )
}

LoginDialogInner.defaultProps = {
  values: {
    email: '',
    password: '',
  },
  touched: {},
  errors: {},
  handleChange: undefined,
  handleBlur: undefined,
  handleSubmit: undefined,
  state: false,
  onClick: undefined,
  onClose: undefined,
  forgot: undefined,
  signup: undefined,
}

LoginDialogInner.propTypes = {
  values: PropTypes.shape({
    email: PropTypes.string,
    password: PropTypes.string,
  }),
  touched: PropTypes.shape({}),
  errors: PropTypes.shape({}),
  handleChange: PropTypes.func,
  handleBlur: PropTypes.func,
  handleSubmit: PropTypes.func,
  state: PropTypes.bool,
  onClick: PropTypes.func,
  onClose: PropTypes.func,
  forgot: PropTypes.func,
  signup: PropTypes.func,
}

LoginDialogInner.displayName = 'LoginDialogInner'

export default LoginDialogInner
